import { cn } from '../../lib/cn';
import { Button } from '../ui';

type Props = {
  actions?: string[];
  activeView?: string;
  views?: string[];
  onViewChange?: (view: string) => void;
  onAction?: (action: string) => void;
  className?: string;
};

export function WorkspaceToolbar({
  actions = ['Create', 'Refresh', 'Export', 'Filters', 'Command Palette'],
  activeView,
  views = ['Table', 'Card'],
  onViewChange,
  onAction,
  className,
}: Props) {
  return (
    <div className={cn('flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 pb-3 dark:border-slate-700', className)}>
      <div className="flex flex-wrap gap-1">
        {actions.map((action) => (
          <Button
            key={action}
            variant={action === 'Create' ? 'primary' : 'secondary'}
            size="sm"
            onClick={() => onAction?.(action)}
          >
            {action}
          </Button>
        ))}
      </div>
      {views.length > 0 && (
        <div className="flex rounded-lg border border-slate-200 p-0.5 dark:border-slate-700">
          {views.map((view) => (
            <button
              key={view}
              type="button"
              onClick={() => onViewChange?.(view)}
              className={cn(
                'rounded-md px-3 py-1 text-xs font-medium transition',
                activeView === view
                  ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300'
                  : 'text-slate-600 hover:bg-slate-50 dark:text-slate-400 dark:hover:bg-slate-800',
              )}
            >
              {view}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
